import { render, staticRenderFns } from "./CategoryMappings.vue?vue&type=template&id=f0ef1d26&scoped=true&"
import script from "./CategoryMappings.vue?vue&type=script&lang=ts&"
export * from "./CategoryMappings.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryMappings.vue?vue&type=style&index=0&id=f0ef1d26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ef1d26",
  null
  
)

export default component.exports